export default __webpack_public_path__ + "static/media/Ambulance-USA-Contact-US-1-832-872-6667.4f394bd6.jpg";